module.exports = __webpack_public_path__ + "img/geep-logo.34a9ceac.jpeg";